import { useEffect, useState } from 'react';

export const isGoogleMapsLoaded = (): boolean => {
  return Boolean((window as any)?.google?.maps?.places?.Autocomplete);
};

export const waitForGoogleMaps = (maxWaitTime = 10000): Promise<boolean> => {
  return new Promise((resolve) => {
    if (isGoogleMapsLoaded()) {
      resolve(true);
      return;
    }

    const startTime = Date.now();
    const checkInterval = 100;

    const interval = window.setInterval(() => {
      if (isGoogleMapsLoaded()) {
        window.clearInterval(interval);
        resolve(true);
        return;
      }

      if (Date.now() - startTime > maxWaitTime) {
        window.clearInterval(interval);
        resolve(false);
      }
    }, checkInterval);
  });
};

export const useGoogleMapsStatus = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const loaded = await waitForGoogleMaps(10000);
        setIsLoaded(loaded);
        if (!loaded) {
          setError('Google Maps API failed to load');
        }
      } catch {
        setError('Error loading Google Maps API');
        setIsLoaded(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkStatus();
  }, []);

  return { isLoaded, isLoading, error };
};
